import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export function GraphsRender(component, index) {
    return _jsx(_Fragment, {}); //<Graphs />;
}
